/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import { Component, EventEmitter, Input, Output } from '@angular/core';

import { ActionService } from '../services/action.service';
import { PropertyTypeService } from '../services/property-type.service'; 

import { Action } from '../models/action';
import { Property } from '../models/property';
import { PropertyType } from '../models/property-type';
import { PropertyTypeParameter } from '../models/property-type-parameter';

declare var $: any;

@Component({
    selector: 'app-action-dialog',
    templateUrl: './action-dialog.component.html'
})
export class ActionDialogComponent {
    @Output()
    createOrUpdateEvent = new EventEmitter<boolean>();

    @Input()
    action: Action;
    
    actionTypes: string[] = ['ALERT', 'DIALOG', 'DIALOG_CLOSE', 'EMAIL', 'EVENT', 'FUNCTION',
        'PROPERTY', 'REST', 'SMS', 'TIMER'];
    
    constructor(
        public propertyTypeService: PropertyTypeService) {this.action = new Action();}
    
    public show(): void {
        $("#actionDialog").modal("show");
    }
    
    public hide(): void {
         $("#actionDialog").modal("hide");
    }
    
    isNew(): boolean {
        return this.action != null && this.action.id == null;
    }
    
    isEdit(): boolean {
        return this.action != null && this.action.id != null;   
    }
    
    onSave(): void {
        this.createOrUpdateEvent.emit(true);
    }
    
    addProperty(): void {
        if (this.action.properties == null) {
            this.action.properties = []; 
        }

        this.action.properties.push(new Property());
    }
    
    removeProperty(property: Property): void {
        const index = this.action.properties.indexOf(property);
        
        if (index > -1) {
            this.action.properties.splice(index, 1);
        }
    }
    
    getPropertyTypes(): string[] {
        return Object.keys(PropertyType);
    }
    
    getParametersForPropertyType(propertyType: PropertyType): PropertyTypeParameter[] {
        return this.propertyTypeService.getParametersForPropertyType(propertyType);
    }

}
